var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offlineConfirmed)?_c('h1',[_vm._v(" The page timed out while loading. Are you sure you're still connected to the Internet? ")]):_c('LoadingView')}
var staticRenderFns = []

export { render, staticRenderFns }